// --- START OF FILE ModalBaseStyle.js ---

import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; }`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3000; // Z-index alto para ficar sobre outros modais
    animation: ${fadeIn} 0.3s ease;
    padding: 20px;
    box-sizing: border-box;
`;

export const ModalContainer = styled.div`
    background: #282828;
    border-radius: 8px;
    width: 100%;
    max-width: ${({ size }) => (size === 'large' ? '900px' : size === 'small' ? '450px' : '600px')};
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0,0,0,0.5);
    animation: ${slideIn} 0.4s ease-out;
    border: 1px solid rgba(255,255,255,0.1);
`;

export const ModalHeader = styled.div`
    padding: 20px 30px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    
    h3 {
        margin: 0;
        color: #E6AA3A;
        font-size: 22px;
    }
`;

export const CloseButton = styled.button`
    background: transparent;
    border: none;
    color: #fff;
    font-size: 28px;
    cursor: pointer;
    opacity: 0.7;
    transition: all 0.3s;
    line-height: 1;
    &:hover { opacity: 1; transform: rotate(90deg); }
`;

export const ModalBody = styled.div`
    padding: 30px;
    overflow-y: auto;
    flex-grow: 1;
`;

export const ModalFooter = styled.div`
    padding: 20px 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    background-color: rgba(0,0,0,0.2);
    border-radius: 0 0 8px 8px;
    flex-shrink: 0;
`;

export const BaseButton = styled.button`
    border: none;
    border-radius: 6px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const CancelButton = styled(BaseButton)`
    background: rgba(255,255,255,0.1);
    color: #fff;
    &:hover:not(:disabled) { background: rgba(255,255,255,0.2); }
`;

export const SaveButton = styled(BaseButton)`
    background: #E6AA3A;
    color: #111;
    &:hover:not(:disabled) { background: #FFC300; }
`;